import {TypesOfPlansEnum} from 'presentation/pages/private/health-card/constants';

enum OurDoctorCardConstants {
	OUR_DOCTOR_CARD_MODEL = '3',
	OUR_DOCTOR_CARD_PARTNER_LOGO = '1',
}

const NEW_WALLET_PLAN_TYPES = [
	TypesOfPlansEnum.OURO,
	TypesOfPlansEnum.PRATA,
	TypesOfPlansEnum.DIAMANTE,
];

export {OurDoctorCardConstants, NEW_WALLET_PLAN_TYPES};
